module.exports = __webpack_public_path__ + "assets/img/2251591947409_.pic_hd.48a3b93a.jpg";